module.exports = __webpack_public_path__ + "img/tu3.ffa11d2b.png";